<template>
    <div class="promocode" :class="{ active: active && !promocode.used }" @click="usePromocode()">
        <p class="promocode__code">{{ promocode.code }}</p>
        <div class="promocode-panel" @click.stop>
            <div class="promocode-panel__item" @click="info = !info">
                <img src="@/assets/images/icons/paper.svg" />
                <div class="promocode-info" v-if="info">
                    <p class="promocode-info__description">{{ promocode.description }}</p>
                    <p class="promocode-info__expiration">{{ active ? 'Истечёт' : 'Истёк' }} {{ promocode.date_expiration }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Promocode',
    data: () => {
        return {
            info: false
        }
    },
    props: {
        promocode: {
            type: Object,
            required: true
        }
    },
    computed: {
        active () {
            return this.$moment(this.promocode.date_expiration) > this.$moment()
        }
    },
    methods: {
        usePromocode () {
            this.$copyText(this.promocode.code)
            this.$axios.post('/api/promocodes/use', {promocode_id: this.promocode.id})
                .then(res => {
                    console.log(res, 'res');
                    this.promocode.used = res.data
                    res.data ? this.$store.dispatch('addNotification', { message: 'Промокод скопирован' }) : ''
                })
                .catch(() => {
                    this.$store.dispatch('addError', { message: 'Что-то пошло не так...' })
                })
            // send use promocode
        }
    }
}
</script>
<style lang="stylus" scoped>
.promocode
    padding 7px 15px
    border-radius 8px
    background-color #eaeaea
    display flex
    align-items center
    position relative
    cursor pointer
    &.active
        background-color #80eec0

    &__code
        margin-right 8px
        font-size 16px
        font-weight 600
    
    &-panel
        &__item
            position relative
    &-info
        position absolute
        right 20px
        top 0
        padding 10px
        background-color white
        border-radius 10px
        font-size 12px
        font-weight 500
        line-height 16px
        box-shadow 0 0 30px rgba(130,130,130, 0.35)
        width 280px
        &__expiration
            margin-top 5px
            color #aaa
</style>